import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

import ApplicationList from "@/modules/application/user/components/ApplicationList";
import { fetchApplicationVersionsQueryOptions } from "@/modules/application/user/services";

export const Route = createFileRoute(
  "/_panel/_application/application/applications/",
)({
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Processes", { ns: "application.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(
      fetchApplicationVersionsQueryOptions(),
    ),
  component: Component,
});

function Component() {
  return (
    <div>
      <ApplicationList />
    </div>
  );
}
